module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAIVJREFUKBVjZCje68nw7+8sBgYGGSAmFjxhYGJOYwFrZGRIZ+hz20asToaS3d4Mf0EWFu76T7QmZIVAfUzIfFLZ2DUX7QplKNq1CsMwNFdi14yhC7sAYc0gF4BcggWgakZzFhb1KEKomlGkCHMGTvPAJpIn4LRKOHwQKkBpm4HhCSMluQoAeZ4sCN14fosAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/isPlay.png
// module id = 1aXW
// module chunks = 1